<template>
  <v-container
    fluid
    grid-list-md
  >
    <v-layout row wrap>
      <v-flex xs12>
        <v-toolbar flat>
          <h2>Заявки на комплексное питание</h2>
          <v-menu
            open-on-hover
            offset-y
            bottom
          >
            <template v-slot:activator="{ on }">
              <v-btn
                v-on="on"
                text
                class="mx-3"
              >
                <span v-if="position">
                  <span>Класс: {{position.name}}</span>
                  &nbsp;
                  <span>[{{position.schoolid}}]</span>
                </span>
                <span v-else>Выберите класс</span>
                <v-icon dark>expand_more</v-icon>
              </v-btn>
            </template>
            <v-flex>
              <v-card>
                <v-card-text>
                  <v-btn
                    :color="item.tgeneral === true ? 'primary' : ''"
                    small
                    text
                    v-for="item in positions"
                    @click="() => { position = item }"
                  >
                    <span>{{item.name}}</span>
                    &nbsp;
                    <span class="grey--text">[{{item.schoolid}}]</span>
                  </v-btn>
                </v-card-text>
              </v-card>
            </v-flex>
          </v-menu>

          <v-select
            v-if="availableCafes.length > 1"
            :items="availableCafes"
            item-text="title"
            item-value="cafeid"
            v-model="cafe"
            label="Выберите столовую"
            return-object
            hide-details
            class="cafe-selector"
          >
            <template slot="selection" slot-scope="data">
              <span style="color:red">
                <strong>{{ data.item.title }}</strong>
              </span>
            </template>
          </v-select>

          <v-menu
            bottom
            :close-on-content-click="true"
            :return-value.sync="date"
            offset-y
          >
            <template v-slot:activator="{ on }">
              <v-text-field
              class="mx-3"
              :width="200"
              v-model="day"
              label="Выберите дату"
              prepend-icon="event"
              readonly
              v-on="on"
              hide-details
              style="max-width: 150px"
              ></v-text-field>
            </template>
            <v-date-picker
              v-model="date"
              @input="setDay()"
              @change="setDay()"
              locale="ru"
              first-day-of-week="1"
              width="300"
              landscape
            >
            </v-date-picker>
          </v-menu>

          <v-btn color="primary" icon class="mx-3" @click="fetch()" :disabled="refreshDisabled">
            <v-icon>refresh</v-icon>
          </v-btn>

          <v-spacer></v-spacer>
          <v-text-field
            v-model="search"
            append-icon="search"
            label="Поиск"
            single-line
            hide-details
            clearable
            style="max-width: 400px"
          ></v-text-field>

        </v-toolbar>
      </v-flex>
      <v-flex xs12>
        <v-data-table
          no-data="пусто" no-data-text="пусто" no-results-text="ничего не найдено"
          :items-per-page="-1"
          :headers="headers"
          :items="persons"
          class="elevation-1"
          item-key="personid"
          :search="search"
          sortBy="fullname"
          hide-default-footer
          hide-default-header
          dense
        >
          <template v-slot:header = "{ props }">
            <tr class="grey--text text--darken-1" style="font-size: 12px">
              <th
                v-for="header in props.headers"
                :class="header.complex ? 'complex-name-header' : ''"
              >
                <v-flex v-if="header.complex">
                  <v-tooltip color="rgb(80,80,80)" bottom>
                    <template v-slot:activator="{ on }">
                      <span v-on="on">
                        <span
                        class="primary--text text--darken-1"
                        style="font-size: 14px"
                        >
                        ({{complexCount(header.complex.complexid)}})
                      </span>
                      {{ header.text }}
                      </span>
                    </template>
                    <p>
                      <b>Цена: {{ rubles(header.complex.price) }}</b>
                    </p>
                    <span v-for="product in header.complex.products.products">
                      <b>{{rubles(product.price)}}</b> - {{product.title}} <br />
                    </span>
                  </v-tooltip>
                </v-flex>
                <span v-else>
                  {{ header.text }}
                </span>
              </th>
            </tr>
          </template>

          <template v-slot:item = "{ item, index }">
            <tr>
              <td style="width: 300px">
                <code class="elevation-0">{{(' ' + (index + 1)).slice(-2)}}</code>&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;{{item.fullname}}
              </td>
              <td v-for="complex in filteredComplexes">
                <v-tooltip color="rgb(80,80,80)" top>
                  <template v-slot:activator="{ on }">
                    <v-btn
                      :disabled="complex.day !== today"
                      small
                      text
                      v-on="on"
                      @click="toggle(item, complex)"
                    >
                      <v-icon v-if="feeds(item, complex.complexid) === true" color="primary">check_box</v-icon>
                      <v-icon v-else color="grey lighten-1">check_box_outline_blank</v-icon>
                    </v-btn>
                  </template>
                  <span>
                    <b>{{item.fullname}}</b><br />
                    {{cafes[complex.cafeid].title}}<br />
                    {{complex.title}}<br />
                    <v-chip small v-if="complex.saletypeid > 3" color="blue">бесплатный вид питания</v-chip>
                    <v-chip small v-else color="red lighten-2">списание с карты</v-chip>
                  </span>
                </v-tooltip>
              </td>
            </tr>
          </template>
        </v-data-table>
      </v-flex>
      <v-dialog
        v-if="position && !position.studytype || studytypedialog === true"
        v-model="studytypedialog"
        scrollable
        persistent :overlay="true"
        max-width="500px"
        transition="dialog-transition"
      >
        <v-card>
          <v-card-title primary-title>
            Выбор формы обучения
          </v-card-title>
          <v-card-text>
            Выберите форму обучения для класса <b>{{ position.name }}</b>
            <v-select
              :items="studytypes"
              v-model="position.studytype"
              label="Выберите форму обучения"
            ></v-select>
          </v-card-text>
          <v-card-actions>
            <v-btn
              :disabled="!this.position || !this.position.studytype"
              color="primary"
              @click="saveStudyType()"
            >Сохранить</v-btn>
          </v-card-actions>
        </v-card>
      </v-dialog>
    </v-layout>
  </v-container>
</template>

<script>
import moment from 'moment'
export default {
  name: 'Requests',
  data: () => ({
    position: null,
    date: moment().format('YYYY-MM-DD'),
    day: moment().format('YYYY-MM-DD'),
    wasInitialized: false,
    persons: [],
    complexes: [],
    filteredComplexes: [],
    cafes: {},
    availableCafes: [],
    cafe: {},
    search: '',
    refreshDisabled: true,
    today: moment().format('YYYY-MM-DD'),
    studytypedialog: false,
    studytypes: [{ text: '5-дневка', value: 5 }, { text: '6-дневка', value: 6 }]
  }),
  methods: {
    complexCount (complexid) {
      return this.persons.reduce((r, x) => {
        if (this.feeds(x, complexid)) r++
        return r
      }, 0)
    },
    feeds (person, complexid) {
      return person[`complex-${complexid}`] !== null
    },
    async toggle (person, complex) {
      const { complexid } = complex
      const { personid } = person
      const requid = `${this.cafe.cafeid}${moment().valueOf()}`
      if (this.feeds(person, complex.complexid) === false) {
        try {
          const { meta, check } = await this.$store.dispatch('sioRequest', {
            topic: 'check',
            pl: {
              personid,
              complexid,
              requid
            }
          })
          person[`complex-${complexid}`] = check.checkid
          this.$store.dispatch('snack', meta)
        } catch (err) {
          this.$store.dispatch('snack', err)
        }
      } else {
        try {
          const { meta, check } = await this.$store.dispatch('sioRequest', {
            topic: 'uncheck',
            pl: {
              personid,
              complexid
            }
          })
          person[`complex-${complexid}`] = null
          this.$store.dispatch('snack', meta)
        } catch (err) {
          this.$store.dispatch('snack', err)
        }
      }
    },
    async fetch () {
      let timerId = setTimeout(function updateToday() {
        this.today = moment().format('YYYY-MM-DD')
        clearTimeout(timerId)
        timerId = setTimeout(updateToday, 10 * 60 * 1000)
      }, 10 * 60 * 1000)
      if (!this.position) return
      this.refreshDisabled = true
      try {
        let { meta, persons, requests, complexes, cafes } = await this.$store.dispatch('sioRequest', {
          topic: 'fetch-class',
          pl: {
            positionid: parseInt(this.position.positionid),
            day: this.day
          }
        })
        let ind = 0
        this.persons = persons
        this.complexes = complexes
        .map(c => {
          c.totalRequests = requests.filter(r => r.complexid === c.complexid).length
          return c
        })
        .filter(c => (c.lockedat === null) || (c.totalRequests > 0))
        this.availableCafes = cafes.sort((a, b) => a.title.localeCompare(b.title))
        this.cafe = this.availableCafes.find(cafe => cafe.cafeid === parseInt(localStorage.getItem('cafe')), 10) || this.availableCafes[0]
        this.filteredComplexes = this.complexes.filter(complex => complex.cafeid === (localStorage.getItem('cafe') || this.cafe.cafeid))
        this.cafes = cafes.reduce((r, x) => {
          r[x.cafeid] = x
          return r
        }, {})
      } catch (err) {
        this.$store.dispatch('snack', err)
      } finally {
        setTimeout(() => {
          this.refreshDisabled = false
        }, 2000)
      }
    },
    setDay () {
      this.day = moment(this.date).format('YYYY-MM-DD')
    },
    rubles (kops) {
      return (parseFloat(kops) / 100).toFixed(2)
    },
    async saveStudyType () {
      const { position } = await this.$store.dispatch('sioRequest', {
        topic: 'save-studytype',
        pl: {
          positionid: this.position.positionid,
          studytype: this.position.studytype
        }
      })
      this.position = position
      this.studytypedialog = false
    }
  },
  computed: {
    positions () {
      if (!this.profile || !this.profile.classhead) return []
      return this.profile.classhead
    },
    headers () {
      const headers = [
        { text: 'Ученик', value: 'fullname', sortable: false },
        ...this.filteredComplexes.map(x => {
          const text = `${x.title} @ ${this.cafes[x.cafeid].title}`
          const value = `complex-${x.complexid}`
          return { complex: x, text, value, sortable: false }
        })
      ]
      return headers
    },
    profile () {
      return this.$store.state.profile
    }
  },
  watch: {
    async profile (val) {
      await this.fetch()
    },
    async day (val) {
      await this.fetch()
    },
    async position (val) {
      if (val) {
        await this.fetch()
        if (this.position && !this.position.studytype) {
          this.studytypedialog = true
        }
      }
    },
    positions (val) {
      if (!val || val.length === 0) return
      this.position = val[0]
    },
    cafe (val) {
      if (!val) return
      localStorage.setItem('cafe', this.cafe.cafeid)
      this.filteredComplexes = this.complexes.filter(complex => complex.cafeid === this.cafe.cafeid)
    }
  },
  mounted () {
    if (this.positions && this.positions.length > 0) {
      this.position = this.positions[0]
    }
    if (this.profile) this.fetch()
  }
}
</script>

<style lang="css">
.complex-name-header {
  white-space: normal;
}
.flat-checkbox {
  margin-top: 0 !important;
}
.cafe-selector {
  width: 200px;
  max-width: 250px;
}
</style>
